module.exports = __webpack_public_path__ + "static/media/optima-seguros-off-app-provider-icon.189056ec.svg";